import { asyncProps, AsyncRequest, FromApiActionPayload, WithRequestId } from '@lib';
import { createAction, props } from '@ngrx/store';
import { PostCheckinConfirmResponse } from 'src/sdk_checkin';
import { CheckinAcceptanceResultModel } from './checkin-acceptance-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinAcceptanceResult] set';
const ACTION_UPDATE = '[CheckinAcceptanceResult] update';
const ACTION_RESET = '[CheckinAcceptanceResult] reset';
const ACTION_FAIL = '[CheckinAcceptanceResult] fail';
const ACTION_CANCEL_REQUEST = '[CheckinAcceptanceResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CheckinAcceptanceResult] set from api';
const ACTION_UPDATE_FROM_API = '[CheckinAcceptanceResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCheckinAcceptanceResult = createAction(
  ACTION_SET,
  props<WithRequestId<CheckinAcceptanceResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCheckinAcceptanceResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CheckinAcceptanceResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinAcceptanceResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCheckinAcceptanceResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCheckinAcceptanceResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCheckinAcceptanceResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostCheckinConfirmResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCheckinAcceptanceResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostCheckinConfirmResponse>>()
);
